'use client';

import { c as _c } from "react/compiler-runtime";
import { timelineData } from '@/data/steveJobsTimeline';
import type { TimelineItem } from '@/types/timeline';
interface SideTimelineProps {
  onItemHover?: (item: TimelineItem | null) => void;
  onItemSelect?: (item: TimelineItem) => void;
  activeIndex?: number;
  isDarkMode?: boolean;
}

// timelineData is static, so the decade labels are too — recomputing them per
// render was pure waste on a component that re-renders as you scroll.
const decadeFirstIndex: Record<number, string> = (() => {
  const seen = new Set<string>();
  const result: Record<number, string> = {};
  timelineData.forEach((item, index) => {
    const decade = Math.floor(item.year / 10) * 10 + 's';
    if (!seen.has(decade)) {
      seen.add(decade);
      result[index] = decade;
    }
  });
  return result;
})();
export default function SideTimeline(t0) {
  const $ = _c(13);
  const {
    onItemHover,
    onItemSelect,
    activeIndex: t1,
    isDarkMode: t2
  } = t0;
  const activeIndex = t1 === undefined ? 0 : t1;
  const isDarkMode = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== onItemSelect) {
    t3 = item => {
      onItemSelect?.(item);
    };
    $[0] = onItemSelect;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleItemClick = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <style>{"\n        ::-webkit-scrollbar { display: none; }\n        * { -ms-overflow-style: none; scrollbar-width: none; }\n      "}</style>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `absolute top-0 right-2 h-full w-px ${isDarkMode ? "bg-neutral-700" : "bg-neutral-300"}`;
  let t6;
  if ($[3] !== t5) {
    t6 = <div className={t5} />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== activeIndex || $[6] !== handleItemClick || $[7] !== isDarkMode || $[8] !== onItemHover) {
    t7 = timelineData.map((item_0, index) => {
      const isActive = index === activeIndex;
      const decade = decadeFirstIndex[index];
      return <div key={item_0.id} className="flex cursor-pointer items-center justify-end transition-[transform,opacity] duration-150" onMouseEnter={() => onItemHover?.(item_0)} onMouseLeave={() => onItemHover?.(null)} onClick={() => handleItemClick(item_0)} onKeyDown={event => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleItemClick(item_0);
        }
      }} role="button" tabIndex={0}>{decade && <div className={`mr-2 text-right text-xs font-medium transition-colors duration-150 ${isActive ? isDarkMode ? "text-white" : "text-black" : isDarkMode ? "text-neutral-500" : "text-neutral-400"}`}>{decade}</div>}<div className={`ease-out-strong h-px transition-[width,background-color] duration-150 ${isActive ? `${decade ? "w-6" : "w-4"} ${isDarkMode ? "bg-white" : "bg-neutral-950"}` : `${decade ? "w-4" : "w-2"} ${isDarkMode ? "bg-neutral-600" : "bg-neutral-300"}`}`} /></div>;
    });
    $[5] = activeIndex;
    $[6] = handleItemClick;
    $[7] = isDarkMode;
    $[8] = onItemHover;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="fixed top-1/2 right-0 z-10 hidden -translate-y-1/2 md:flex">{t4}<div className="relative flex h-[70vh] flex-col justify-between pr-2">{t6}{t7}</div></div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}